import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Job from '@/model/entity/job/job';
import JobInformation from '../job-information/index.vue';
import Util from '@vertical-plus/vue-js-core/dist/util/util';

@Component({
    components:
    {
        'app-job-information': JobInformation,
    },
})
export default class JobPreview extends Vue
{
    @Prop({
        type: Boolean,
        default: false,
    })
    private value!: boolean;

    @Prop()
    private jobId!: string;

    private loading = false;

    private job: Job|null = null;

    private visible = false;

    created()
    {
        this.visible = this.value;

        this.loadJob();
    }

    @Watch('jobId')
    private onJobIdUpdated()
    {
        this.loadJob();
    }

    @Watch('value')
    private onValueUpdated()
    {
        this.visible = this.value;
    }

    @Watch('visible')
    private onDialogValueUpdated()
    {
        this.$emit('input', this.visible);
    }

    private async loadJob()
    {
        this.loading = true;

        try
        {
            await Util.execMinTime(async() =>
            {
                this.job = await this.$serviceContainer.jobService.loadJob(this.jobId);
            }, 500);
        }
        catch (error)
        {
            //
        }

        this.loading = false;
    }
}